import { STRINGS } from 'config';

const { APP_ID, ENABLED } = STRINGS.INTERCOM as { APP_ID: string; ENABLED: boolean };

function ifIntercomIsEnabled<T extends(...args: unknown[]) => unknown>(func: T): T {
  if (!ENABLED) {
    return (() => null) as T;
  }
  return func;
}

export const initiateIntercom = ifIntercomIsEnabled((): unknown => (
  window.Intercom && window.Intercom('boot', { app_id: APP_ID })
));

export const setupIntercom = ifIntercomIsEnabled((): unknown => {
  (function () {
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      const d = document;
      interface IntercomTemporary {
        (...args: unknown[]): void;
        q: unknown[];
        c: (args: unknown[]) => void;
      }
      const i = (function (...args: unknown[]): void {
        (i as IntercomTemporary).c(args);
      } as unknown) as IntercomTemporary;
      i.q = [];
      i.c = function (args: unknown[]): void {
        i.q.push(args);
      };
      w.Intercom = i;
      const l = function (): void {
        const s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${APP_ID}`;
        const x = d.getElementsByTagName('script')[0];
        x.parentNode?.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else {
        type WindowWithAttachEvent = Window & {
          attachEvent?: (event: string, listener: () => void) => void;
        };
        const winWithAttach = w as WindowWithAttachEvent;
        if (winWithAttach.attachEvent) {
          winWithAttach.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    }
  }());
  window.intercomSettings = { app_id: APP_ID };
  return initiateIntercom();
});

export const shutDownIntercomSession = ifIntercomIsEnabled((): unknown => (
  window.Intercom && window.Intercom('shutdown')
));

export const updateIntercom = ifIntercomIsEnabled((userData: unknown): unknown => (
  window.Intercom && window.Intercom('update', userData)
));
